import { PROFILE_ACTION_TYPES } from '../../actions/profile';

const INITIAL_STATE = {
  isLoggedIn: false,
  wish_list: { isLoading: false }
};

const profileReducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case PROFILE_ACTION_TYPES.PROFILE_WISHLIST_SAVE:
      return { ...state, wish_list: { ...payload.wishlist, isLoading: false } };
    case PROFILE_ACTION_TYPES.PROFILE_WISHLIST_SAVE_ERROR:
      return { ...state, wish_list: { ...state.wish_list, isLoading: false } };
    case PROFILE_ACTION_TYPES.PROFILE_WISHLIST_LOADING:
      return { ...state, wish_list: { ...state.wish_list, isLoading: payload.isLoading } };
    default:
      return state;
  }
};

export default profileReducer;
